import { TimeHelper } from '@/helpers/TimeHelper';

const tableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true
  },
  {
    prop: 'createdOn',
    label: 'Member since',
    sortable: true
  },
  {
    prop: 'dateLastLogged',
    label: 'Last login',
    sortable: true
  },
  {
    prop: 'status',
    label: 'Status',
    sortable: true
  }
];

const tableFilters = [
  {
    label: 'Inactive',
    name: 'inactive',
    search: 'status',
    param: 'pending'
  },
  // TODO: the current status in PostGres is "deleted", however, it's more behaving like "disabled". In order to keep it consistent with Cognito actions 
  // I have made it show disabled on the front end.
  {
    label: 'Disabled',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  },
  {
    label: 'Recent activity',
    name: 'activity',
    search: 'lastLogin',
    param: TimeHelper.timestampFromDaysAgo(2)
  }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      },
      {
        label: 'Email',
        value: 'email'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions };
